import router from '@/router'
import { getToken } from '@/utils/token'
import store from './store'
import _ from 'lodash'
const whiteList = ['/', '/404', '/bpmToSfterSales']

router.beforeEach(async (to, from, next) => {
  if (to.path === '/bpmToSfterSales') {
    return next()
  }
  if (getToken() && getToken() !== 'null') {
    const userInfo = store.getters['user/basicInfo']
    if (!userInfo) {
      await store.dispatch('user/updateUserInfo')
    }
    return next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/') // 否则全部重定向到登录页
    }
  }
})

router.beforeEach((to, from, next) => {
  if (_.isEmpty(history.state.current)) {
    _.assign(history.state, { current: from.fullPath })
  }
  next()
})

/**
 * 多标签页面拦截
 */
router.beforeEach((to, from, next) => {
  // 判断目标路径是否允许作为标签页面存在，默认为允许，除非特别声明(meta.disableTabMode : true)
  if (!to.meta.disableTabMode) {
    store.dispatch('system/addTab', to)
  }
  next()
})

